module.exports = __webpack_public_path__ + "static/organicbeigemain-1819c5177419066cba7306f68f423f44.jpeg";